package music.jammers.client.shared.component.avatar.presentation.viewmodel

import music.jammers.shared.user.domain.model.User

data class AvatarImageState(
    val user: User? = null,
)